import React, {useEffect} from 'react'
import apiClient from '../http-common';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { setReferrals } from './referalSlice';

 const LoadReferrals = () => {
  const dispatch = useDispatch();

    const { isLoading: isLoadingReferrals, refetch: getReferrals } = useQuery(
        "referrals",
        async () => {
          return await apiClient.get("/api/referrals");
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                dispatch(setReferrals(res.data.referrals))
                const event = new Event('updatedStorage');
                window.dispatchEvent(event);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      useEffect(() => {
        getReferrals();
      }, []);
 
}

export default LoadReferrals
